import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { checkInputErrorRequired } from '@chilecompra/react-kit'
import { Card, Input, Typography, useInput } from '@chilecompra/react-kit/components'
import { formatTypeCurrency } from '../../modules/utils/formatTypeCurrency'
import { CURRENCY_SIGNS } from '../../config/settings/constants'
import { GridContainer, GridItem } from './QuoteBidSeller.styles'
import { AmountPrefix } from '../QuoteStepOne/QuoteStepOne.styles'

/**
 * The Quote Bid Dispatch Value's component.
 */
const QuoteBidDispatchValue = props => {
  const { areThereProductsIncluded, calculateDispatchValue, typeCurrency, disabled } = props
  const {
    onChange: handleDispatchValueChange,
    value: dispatchValue,
    setValue: setDispatchValue
  } = useInput({
    initialValue: '',
    errorCallbacks: [checkInputErrorRequired()]
  })

  useEffect(() => {
    let aux
    if (typeCurrency === 'CLP') {
      aux = dispatchValue.replace(/[^0-9]/g, '')
    } else {
      aux = dispatchValue.replace(/[^0-9,]/g, '').replace(/,/g, '.')
    }
    if (isNaN(aux) || aux === '') {
      setDispatchValue('')
      calculateDispatchValue(0)
      return
    }

    const validationAfterComma = aux.split('.')
    if (aux.slice(-1) === ',' || aux.slice(-1) === '.') {
      if (validationAfterComma.length > 2) {
        aux = aux.slice(0, -1)
      } else if (
        validationAfterComma.length === 2 &&
        validationAfterComma[1] === '' &&
        dispatchValue.slice(-1) === ','
      ) {
        return
      }
    }

    setDispatchValue(formatTypeCurrency(typeCurrency, aux))
    calculateDispatchValue(aux)
  }, [dispatchValue])

  useEffect(() => {
    if (areThereProductsIncluded) {
      return
    }

    setDispatchValue('')
  }, [areThereProductsIncluded])

  return (
    <GridContainer padding="8px 0 0">
      <GridItem lg={6} md={12} sm={12} xs={12} />
      <GridItem lg={6} md={12} sm={12} xs={12}>
        <Card enableBorder color="blank">
          <GridContainer alignItems="center" spacing={3}>
            <GridItem lg={5} md={12} sm={12} xs={12}>
              <Typography color="black1" fontSize="14px" fontWeight="bold" lineHeight="18px" variant="body1">
                Valor de despacho
              </Typography>
            </GridItem>
            <GridItem lg={7} md={12} sm={12} xs={12}>
              <Input
                disabled={disabled ? true : !areThereProductsIncluded}
                label="Despacho"
                onChange={handleDispatchValueChange}
                prefix={<AmountPrefix>{CURRENCY_SIGNS[typeCurrency]}</AmountPrefix>}
                value={dispatchValue}
              />
            </GridItem>
          </GridContainer>
        </Card>
      </GridItem>
    </GridContainer>
  )
}

QuoteBidDispatchValue.propTypes = {
  areThereProductsIncluded: PropTypes.bool.isRequired,
  calculateDispatchValue: PropTypes.func.isRequired,
  typeCurrency: PropTypes.string.isRequired,
  disabled: PropTypes.bool
}

export default QuoteBidDispatchValue
